// extracted by mini-css-extract-plugin
export default {"sidebarPage":"SidebarPage_sidebarPage__iInj1"};